module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-dialog', {
    attrs: {
      "title": "重要提示",
      "visible": _vm.visible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning-outline",
    staticStyle: {
      "font-size": "100px",
      "color": "#facea8"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "22px"
    }
  }, [_vm._v(_vm._s(_vm.content))])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "footerbtn cancle",
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('el-button', {
    staticClass: "footerbtn",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.okText))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a896db20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/popUp.vue
// module id = 1732
// module chunks = 3